/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class ReturnGoods extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default ReturnGoods;


// WEBPACK FOOTER //
// ./src/routes/returnGoods/index.js